// app
export const START_LOADING = 'START_LOADING';
export const STOP_LOADING = 'STOP_LOADING';
export const INITIALIZE = 'INITIALIZE';
export const CONFIUGRE = 'CONFIUGRE';
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const SET_SELECTED = 'SET_SELECTED';
export const FETCH_MOVIE_GENRES = 'FETCH_MOVIE_GENRES';
export const FETCH_TVSHOW_GENRES = 'FETCH_TVSHOW_GENRES';
// items
export const FETCH_ITEMS_START = 'FETCH_ITEMS_START';
export const FETCH_ITEMS_FINISH = 'FETCH_ITEMS_FINISH';
export const CHANGE_ITEMS_PAGE = 'CHANGE_ITEMS_PAGE';
export const FETCH_ITEMS = 'FETCH_ITEMS';
//singleIItem
export const FETCH_SINGLEITEM_START = 'FETCH_SINGLEITEM_START';
export const FETCH_SINGLEITEM_FINISH = 'FETCH_SINGLEITEM_FINISH';
export const FETCH_SINGLEITEM = 'FETCH_SINGLEITEM';
//recomandations
export const FETCH_REC_START = 'FETCH_REC_START';
export const FETCH_REC = 'FETCH_REC';
export const FETCH_REC_FINISH = 'FETCH_REC_FINISH';
export const CHANGE_REC_PAGE = 'CHANGE_REC_PAGE';
//discover
export const DISCOVER_START = 'DISCOVER_START';
export const DISCOVER_FINISH = 'DISCOVER_FINISH';
export const DISCOVER = 'DISCOVER';
export const CHANGE_DISCOVER_PAGE = 'CHANGE_DISCOVER_PAGE';
//peoples
export const FETCH_PERSON_START = 'FETCH_PERSON_START';
export const FETCH_PERSON_FINISH = 'FETCH_PERSON_FINISH';
export const FETCH_PERSON = 'FETCH_PERSON';
export const FETCH_MOVIE_WITH_PERSON = 'FETCH_MOVIE_WITH_PERSON';
//acting
export const FETCH_ACTING_START = 'FETCH_ACTING_START';
export const FETCH_ACTING_FINIHS = 'FETCH_ACTING_FINIHS';
export const FETCH_ACTING = 'FETCH_ACTING';
export const CHANGE_ACTING_PAGE = 'CHANGE_ACTING_PAGE';
//search
export const SEARCH_START = 'SEARCH_START';
export const SEARCH_FINISH = 'SEARCH_FINISH';
export const SEARCH = 'SEARCH';
export const CHANGE_SEARCH_PAGE = 'CHANGE_SEARCH_PAGE';
//error
export const CATCH_ERROR = 'CATCH_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
